import { LandingPage } from '@/components/LandingPage';
import React from 'react';

export default function Home() {
  return <LandingPage />;
}
